var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default',[_c('div',{staticClass:"cust-motor-wrap"},[_c('motor-apply-page')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }